<ng-container *ngIf="!!params">
    <div *ngIf="!('mobile' | mediaQuery)" class="col-xs-12 sp-0">
        <div class="col-xs-3 sp-0">
            <tt-card class="col-xs-12 p-2" ttHeading="h_basics" ttAccordion ttRememberId="w_product.card.basics">
                <tt-product-basic-form [(params)]="params" (paramsChange)="paramsChange.emit($event)"></tt-product-basic-form>
            </tt-card>
        </div>
        <div class="col-xs-3 sp-0">
            <tt-card class="col-xs-12 p-2" ttHeading="h_product_own_kpi" ttAccordion ttRememberId="w_product.card.kpi">
                <tt-product-kpi-form [params]="params"></tt-product-kpi-form>
            </tt-card>

            <tt-card class="col-xs-12 p-2" ttHeading="h_stock" ttAccordion ttRememberId="w_product.card.stock">
                <tt-product-stock-form [(params)]="params" (paramsChange)="paramsChange.emit($event)"></tt-product-stock-form>
            </tt-card>

            <tt-card *ngIf="params.show_pim_data === '1'" class="col-xs-12 p-2" ttHeading="h_product_pim_data" ttAccordion ttRememberId="w_product.card.pim">
                <tt-product-pim-form [(params)]="params" (paramsChange)="paramsChange.emit($event)"></tt-product-pim-form>
            </tt-card>
        </div>

        <div class="col-xs-3 sp-0">
            <tt-card class="col-xs-12 p-2" ttHeading="h_purchase" ttAccordion ttRememberId="w_product.card.purchase">
                <tt-product-purchase-form [(params)]="params" (paramsChange)="paramsChange.emit($event)"></tt-product-purchase-form>
            </tt-card>
            <tt-card class="col-xs-12 p-2" ttHeading="h_product_production" ttAccordion ttRememberId="w_product.card.production">
                <tt-product-production-form [(params)]="params" (paramsChange)="paramsChange.emit($event)"></tt-product-production-form>
            </tt-card>
        </div>
        <div class="col-xs-3 sp-0">
            <tt-card class="col-xs-12 p-2" ttHeading="h_functions" ttAccordion ttRememberId="w_product.card.functions">
                <tt-product-functions [params]="params"></tt-product-functions>
            </tt-card>
        </div>
    </div>
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-tabs #tabs>
            <tt-tab ttId="BASIC" ttLabel="bg_product_view_basic"> </tt-tab>
            <tt-tab ttId="OTHER" ttLabel="bg_product_view_other"></tt-tab>
            <tt-tab ttId="FUNCTIONS" ttLabel="bg_product_view_functions"></tt-tab>
        </tt-tabs>
        <div [hidden]="tabs.ttSelectedId !== 'BASIC'">
            <tt-card class="col-xs-12 p-2" ttHeading="h_basics" ttAccordion ttRememberId="w_product.mobile.card.basics">
                <tt-product-basic-form [(params)]="params" (paramsChange)="paramsChange.emit($event)"></tt-product-basic-form>
            </tt-card>
            <tt-card *ngIf="params.show_pim_data === '1'" class="col-xs-12 p-2" ttHeading="h_product_pim_data" ttAccordion ttRememberId="w_product.mobile.card.pim">
                <tt-product-pim-form [(params)]="params" (paramsChange)="paramsChange.emit($event)"></tt-product-pim-form>
            </tt-card>
        </div>
        <div [hidden]="tabs.ttSelectedId !== 'OTHER'">
            <tt-card class="col-xs-12 p-2" ttHeading="h_stock" ttAccordion ttRememberId="w_product.mobile.card.stock">
                <tt-product-stock-form [(params)]="params" (paramsChange)="paramsChange.emit($event)"></tt-product-stock-form>
            </tt-card>
            <tt-card class="col-xs-12 p-2" ttHeading="h_purchase" ttAccordion ttRememberId="w_product.mobile.card.purchase">
                <tt-product-purchase-form [(params)]="params" (paramsChange)="paramsChange.emit($event)"></tt-product-purchase-form>
            </tt-card>
            <tt-card class="col-xs-12 p-2" ttHeading="h_product_production" ttAccordion ttRememberId="w_product.mobile.card.production">
                <tt-product-production-form [(params)]="params" (paramsChange)="paramsChange.emit($event)"></tt-product-production-form>
            </tt-card>
        </div>
        <tt-card class="col-xs-12 p-2">
            <tt-product-functions [hidden]="tabs.ttSelectedId !== 'FUNCTIONS'" [params]="params"></tt-product-functions>
            <div [hidden]="tabs.ttSelectedId === 'FUNCTIONS'">
                <tt-product-edit-save [params]="params"></tt-product-edit-save>
                <tt-button-settings *ngIf="params.show_setting === '1'" ttWebpageName="product"></tt-button-settings>
            </div>
        </tt-card>
    </ng-container>
</ng-container>
